export default __webpack_public_path__ + "static/media/support.5e27059f.svg";